export enum TipoFormatacao {
  FORMATO_DATA = "DD/MM/YYYY",
  FORMATO_DATA_HORA = "DD/MM/YYYY HH:mm",
}
